export default ":host [ngbdropdowntoggle]::after {\n  display: inline-block !important;\n}"